<template>
  <v-row>
    <v-col md="12" class="hover-grey">
      <display-data
        :display-title="`Name`"
        :display-value="clientDetail.name"
      ></display-data>
    </v-col>
    <v-col v-if="clientDetail.client_type !== 'b2c'" cols="12" class="hover-grey">
      <display-data
        :display-title="`Alternate Name`"
        :display-value="
          (clientDetail.b2b && clientDetail.b2b.alternate_name) || `N/A`
        "
      ></display-data>
    </v-col>
    <v-col v-if="clientDetail.client_type !== 'b2c'" cols="12" class="hover-grey">
      <display-data
        :display-title="`Abbreviation`"
        :display-value="
          (clientDetail.b2b && clientDetail.b2b.abbreviation) || `N/A`
        "
      ></display-data>
    </v-col>
    <v-col cols="12" class="hover-grey">
      <display-data
        :display-title="`Email`"
        :display-value="clientDetail.email || `N/A`"
      ></display-data>
    </v-col>
    <v-col v-if="clientDetail.client_type !== 'b2c'" cols="12" class="hover-grey">
      <display-data
        :display-title="`Industry`"
        :display-value="clientDetail.b2b && clientDetail.b2b.industry_name"
      ></display-data>
    </v-col>
    <v-col cols="12" class="hover-grey">
      <display-data
        :display-title="`Website`"
        :display-value="clientDetail.website"
        link
      ></display-data>
    </v-col>
    <v-col cols="12" class="hover-grey">
      <display-data
        :display-title="`Public`"
        :display-value="clientDetail.is_public ? `Yes` : `No`"
      ></display-data>
    </v-col>
    <v-col v-if="clientDetail.client_type !== 'b2c'" cols="12" class="hover-grey">
      <display-data
        :display-title="`Client Size`"
        :display-value="
          (clientDetail.b2b && clientDetail.b2b.client_size) || `N/A`
        "
      ></display-data>
    </v-col>
    <v-col cols="12">
      <display-data
        :display-title="`Client Value`"
        :display-value="clientDetail.client_value || `N/A`"
        class="hover-grey"
      ></display-data>
    </v-col>
    <v-col cols="12">
      <display-data
        :display-title="`Merojob Id`"
        :display-value="clientDetail.reference_id || `N/A`"
        class="hover-grey"
      ></display-data>
    </v-col>
    <v-col v-if="clientDetail.client_type === 'b2c'" cols="12">
      <display-data
        :display-title="`Date of Birth`"
        :display-value="clientDetail.b2c.dob || `N/A`"
        class="hover-grey"
      ></display-data>
    </v-col>
    <v-col v-if="clientDetail.client_type === 'b2c'" cols="12">
      <display-data
        :display-title="`Gender`"
        :display-value="(clientDetail.b2c && clientDetail.b2c.gender) || `N/A`"
        class="hover-grey"
      ></display-data>
    </v-col>
    <v-col v-if="clientDetail.client_type === 'b2c'" cols="12">
      <display-data
        :display-title="`Marital Status`"
        :display-value="
          (clientDetail.b2c && clientDetail.b2c.marital_status) || `N/A`
        "
        class="hover-grey"
      ></display-data>
    </v-col>
    <v-col v-if="clientDetail.client_type === 'b2c'" cols="12">
      <display-data
        :display-title="`CurrentAddress`"
        :display-value="
          (clientDetail.b2c && clientDetail.b2c.current_address) || `N/A`
        "
        class="hover-grey"
      ></display-data>
    </v-col>

    <v-col v-if="clientDetail.client_type === 'b2c'" cols="12">
      <display-data
        :display-title="`Permanent Address`"
        :display-value="
          (clientDetail.b2c && clientDetail.b2c.permanent_address) || `N/A`
        "
        class="hover-grey"
      ></display-data>
    </v-col>
    <v-col cols="12">
      <v-divider class="my-2"></v-divider>
      <p class="grey--text">
        {{ clientDetail.about }}
      </p>
    </v-col>
  </v-row>
</template>
<script>
import DisplayData from "@/components/crm/layout_utils/DisplayData";

export default {
  components: { DisplayData },
  props: {
    clientDetail: {
      type: Object,
      required: true
    },
    b2c: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {};
  },
  watch: {
    clientDetail: {
      handler(val) {
        this.clientDetail = val;
      },
      deep: true
    }
  }
};
</script>
